import { useTranslation } from 'react-i18next';
import './index.css';
import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useStore } from '../../store';

interface ContentProps {
  children: ReactNode,
}

export const Content: React.FC<ContentProps> = ({ children }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { invite } = useStore();
  console.log(location.pathname);
  useEffect(() => {
    i18n.changeLanguage(invite?.user_invite?.locale?.split('-')[0]);
  }, [invite]);

  return (
    <main className='content-container'>
      {location.pathname.includes('/register') && <a href="/" className='back-link'><span>&#8592;</span> | {t('back')}</a>}
      {children}
    </main>
  );
}
